import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import logo from "@/assets/sayitinsports-badge.png";

interface WordmarkProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  showBadge?: boolean;
  asLink?: boolean;
}

const sizeMap = {
  sm: { text: "text-xl", badge: "h-7 w-7" },
  md: { text: "text-2xl", badge: "h-9 w-9" },
  lg: { text: "text-4xl", badge: "h-12 w-12" },
};

const Wordmark = ({ size = "md", className, showBadge = true, asLink = false }: WordmarkProps) => {
  const { text, badge } = sizeMap[size];
  const content = (
    <>
      {showBadge && (
        <img
          src={logo}
          alt="Say It In Sports"
          className={cn("rounded-full object-cover shrink-0", badge)}
        />
      )}
      <span className={cn("font-display tracking-tight whitespace-nowrap", text)}>
        <span className="text-secondary">Say It In</span>{" "}
        <span className="serif italic font-bold text-accent">Sports</span>
      </span>
    </>
  );

  const baseClass = cn("inline-flex items-center gap-2.5 leading-none", className);

  if (asLink) {
    return (
      <Link to="/" className={cn(baseClass, "hover:opacity-90 transition-opacity")} aria-label="Say It In Sports — home">
        {content}
      </Link>
    );
  }

  return <span className={baseClass}>{content}</span>;
};

export default Wordmark;
